import { render, staticRenderFns } from "./Jemaat.vue?vue&type=template&id=626404a8&"
import script from "./Jemaat.vue?vue&type=script&lang=js&"
export * from "./Jemaat.vue?vue&type=script&lang=js&"
import style0 from "./Jemaat.vue?vue&type=style&index=0&id=626404a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports